import {axiosInstance} from "../instance";

const TanksList = () => {
    return axiosInstance
        .get('/api/tanks');
}

const Tank = (id) => {
    return axiosInstance
        .get(`/api/tank/${id}`);
}

const TanksListPerUser = () => {
    return axiosInstance
        .get('/api/tanks-per-user');
}

const TankStatement = (id, dateFrom, dateTo) => {
    if (!!dateFrom && !!dateTo) {
        return axiosInstance
            .get(`/api/tank-statement/${id}/${dateFrom}/${dateTo}`);
    } else if (!!dateFrom) {
        return axiosInstance
            .get(`/api/tank-statement/${id}/${dateFrom}`);
    }
    return axiosInstance
        .get(`/api/tank-statement/${id}/${dateFrom}/${dateTo}`);
}

const TankUpdate = (tank) => {
    return axiosInstance
        .post('/api/tank', tank);
}

const TankDelete = (id) => {
    return axiosInstance
        .delete(`/api/tank/${id}`);
}

export {TankUpdate, TanksList, TanksListPerUser, Tank, TankDelete, TankStatement}
